import { AppButton } from "@/shared/Components";
import { SettingIcon } from "@/shared/icons";
import type { AppButtonProps } from "@/shared/Components/AppButton";
import type { FC } from "react";
import styles from "./styles.module.scss";

export const SettingsButton: FC<Pick<AppButtonProps, "onClick">> = ({ onClick }) => {
  return (
    <AppButton onClick={onClick} className={styles["settings-column-title-button"]}>
      <SettingIcon />
    </AppButton>
  );
};
